// extracted by mini-css-extract-plugin
export default {"input":"MaaltijdenForm_input__LxVX0"};